import { useState } from 'react';

import { Input } from '@poseidon/components/Input2';

/**
 * Compact "N days" editor shared by the timing steps — a `wait` duration and an `await_connect`
 * acceptance deadline. Edits locally while typing and commits (clamped to 1–365) on blur / Enter, so we
 * don't fire a save on every keystroke.
 */
export function DurationDaysInput({ days, onCommit }: { days: number; onCommit: (days: number) => void }) {
  const [value, setValue] = useState(String(days));

  const commit = () => {
    const parsed = Math.round(Number(value));
    const next = Number.isFinite(parsed) ? Math.max(1, Math.min(365, parsed)) : days;
    setValue(String(next));
    if (next !== days) onCommit(next);
  };

  return (
    <div className="flex items-center gap-1.5" onClick={(e) => e.preventDefault()}>
      <Input
        type="number"
        min={1}
        max={365}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === 'Enter') e.currentTarget.blur();
        }}
        className="w-16"
      />
      <span className="text-xs text-gray-500 dark:text-gray-400">day{Number(value) === 1 ? '' : 's'}</span>
    </div>
  );
}
